module.exports = __webpack_public_path__ + "media/storehouse.638d7cf0.mp4";